import React, { useState } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { validateExperianOtp } from '../../Actions/creditExperianHistoryAction';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const VerifyViaOTP = (props) => {
    const { handleSuccessOtpValidation } = props;
    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', '']);
    const dispatch = useDispatch();
    const otp1 = useRef();
    const otp2 = useRef();
    const otp3 = useRef();
    const otp4 = useRef();
    const otp5 = useRef();
    const otp6 = useRef();
    const captcha = useRef();

    const [otpVal1, setOtpVal1] = useState();
    const [otpVal2, setOtpVal2] = useState();
    const [otpVal3, setOtpVal3] = useState();
    const [otpVal4, setOtpVal4] = useState();
    const [otpVal5, setOtpVal5] = useState();
    const [otpVal6, setOtpVal6] = useState();
    const [timer, setTimer] = useState(40);
    const [count,setCount]=useState(1);
    const [toggle, setToggle] = useState(false);
    const [otpError, setOtpError] = useState(false);

    const handleOtpChange = (index, value) => {
        if (value.length <= 1 && /^\d*$/.test(value)) {
            const newOtpDigits = [...otpDigits];
            newOtpDigits[index] = value;
            setOtpDigits(newOtpDigits);
        }
    };

    const handleBackClick = () => {
        // Add logic for back button click
        // console.log('Back button clicked');
        window.location.reload();
    };

    const handleVerifyClick = () => {
        // Add logic for verify button click
        const otp = otpDigits.join('');
        console.log('Verifying OTP:', otp);
    };

    const handleOtpInputs = (e) => {
      if (e.target.name == "otp1") {
        setOtpVal1((v) => (e.target.validity.valid ? e.target.value : ""));

        e.target.focus();
      }
      if (e.target.name == "otp2") {
        setOtpVal2((v) => (e.target.validity.valid ? e.target.value : ""));
      }
      if (e.target.name == "otp3") {
        setOtpVal3((v) => (e.target.validity.valid ? e.target.value : ""));
      }
      if (e.target.name == "otp4") {
        setOtpVal4((v) => (e.target.validity.valid ? e.target.value : ""));
      }
      if (e.target.name == "otp5") {
        setOtpVal5((v) => (e.target.validity.valid ? e.target.value : ""));
      }
      if (e.target.name == "otp6") {
        setOtpVal6((v) => (e.target.validity.valid ? e.target.value : ""));
      }
      const finalOtp1 =
        otp1.current.value +
        otp2.current.value +
        otp3.current.value +
        otp4.current.value +
        otp5.current.value +
        otp6.current.value;
      if (finalOtp1.length == 6) {
        setOtpError(false);
      } else {
        setOtpError(true);
      }
      let currentInput = e.target;
      if (e.target.validity.valid == false) {
        e.target.focus();
      } else {
        if (currentInput.value) {
          if (currentInput.nextElementSibling !== null) {
            currentInput?.nextElementSibling.focus();
          }
        }
        if (!currentInput.value) {
          currentInput?.previousElementSibling?.focus();
        }
      }
    };

    const verifyOtpHandler = async (e) => {
        e.preventDefault();
        const finalOtp =
          otp1.current.value +
          otp2.current.value +
          otp3.current.value +
          otp4.current.value +
          otp5.current.value +
          otp6.current.value;
          if (finalOtp == '') {
            setOtpError(true);
          } else {
            if (finalOtp.length != 6) {
              setOtpError(true);
            } else {
                await dispatch(validateExperianOtp({type: "VERIFY_CREDIT_OTP2",
                mobile_otp: finalOtp,}, verifyOTPCallBack));
                handleStart();
                setCount(count+1);
            }
          }
      };

      const verifyOTPCallBack = (result) => {
        if(result?.success == 1){
            // alert("Thank you..");
           const successResponse = {
              "success": 1,
              "type": "VERIFY_CREDIT_OTP2",
              "msg": "Your credit report has been generated",
              "api": 1,
              "CREDIT_BUREAU": "Experian"
          }
          handleSuccessOtpValidation();
        } else {
            console.log("validation failed")
        }
        resetOTPFields();
      }

      const resetOtpHandler = async () => {
        await dispatch(validateExperianOtp({type : "RESEND_CREDIT_OTP2"}, verifyResendOTP));
        handleStart();
        setCount(count+1);
      }

      const verifyResendOTP = (result) => {
        if(result?.success == 1) {
          toast.success(result?.msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
        }
        return;
      }

      const handleStart = () => {
        setTimer(40);
        //setSkiptimer(10);
        setToggle(true);
        setOtpError(false);
      };

      const resetOTPFields = () => {
        setOtpVal1("");
        setOtpVal2("");
        setOtpVal3("");
        setOtpVal4("");
        setOtpVal5("");
        setOtpVal6("");
      };

      useEffect(() => {
        handleStart();
      },[])

      useEffect(() => {
        let counter;
        if (toggle) {
          counter = setInterval(() => {
            if (timer > 0) {
              setTimer(timer => timer - 1);
            } else {
              setTimer(0);
              clearInterval(counter);
              setToggle(false);
            }
          }, 1000);
        }
        
      }, [toggle]);
    return (
        <div className='mt-3'>
            <h6 style={{
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "30px",
                textAlign: "left",
            }}>Verify via OTP</h6>
            <p style={{
                fontSize: "18px",
                fontWeight: "400",
                lineHeight: "24.12px",
                textAlign: "left",
            }}>{`Enter the security code we sent to ${props?.selectedOption || 'alternate number'}.`}</p>
            <form>
                {/* {otpDigits.map((digit, index) => (
                    <input
                        key={index}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        style={{
                            width: "55px",
                            height: "52px",
                            padding: "0 12px",
                            margin: "0 4px",
                            borderRadius: "8px",
                            border: "1px solid #D1D5DB",
                            textAlign: "center",
                            fontSize: "20px",
                            fontWeight: "600",
                        }}
                    />
                ))} */}
                                <div className="">
                  <div className="otp-inputs d-flex justify-content-left">
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      ref={otp1}
                      autoComplete="off"
                      name="otp1"
                      pattern="[0-9]*"
                      value={otpVal1}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp2"
                      autoComplete="off"
                      ref={otp2}
                      pattern="[0-9]*"
                      value={otpVal2}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp3"
                      autoComplete="off"
                      ref={otp3}
                      pattern="[0-9]*"
                      value={otpVal3}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp4"
                      autoComplete="off"
                      ref={otp4}
                      pattern="[0-9]*"
                      value={otpVal4}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp5"
                      autoComplete="off"
                      ref={otp5}
                      pattern="[0-9]*"
                      value={otpVal5}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp6"
                      autoComplete="off"
                      ref={otp6}
                      pattern="[0-9]*"
                      value={otpVal6}
                      onChange={handleOtpInputs}
                    />
                  </div>
                  {otpError ? ( 
                        <span className="ml-8 text-danger fnt-sml-md">
                        Please enter a valid OTP.
                        </span>
                        ) : ''}
                </div>

                <div className="btn-box d-flex justify-content-between w-100 h-100 p-1 pt-3" style={{ maxWidth: "422px", }}>
                    <div className="btn w-100 btn-light text-dark" onClick={handleBackClick} style={{ cursor: "pointer" }}>Back</div>
                    <div className="btn w-100 ml-2 btn-primary text-light" onClick={verifyOtpHandler} style={{ cursor: "pointer" }}>Verify OTP</div>
                </div>
            </form>

            <p style={{
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                textAlign: "left",
                color: "#1D2939",
            }}
                className='mt-3'
            >Didn’t get a code? { timer > 0 ? ( 
              <span className="text-muted">
                
                Resend OTP in {timer} Seconds{" "}
              </span>):<>{ count==5 ? ( <span className="text-muted">
                
                No more attempts left{" "}
                </span>):''}</>}
              {timer < 0 && count<5 ? (
                <Link
                  to="#"
                  className="text-primary"
                  onClick={(e) => {
                    e?.preventDefault();
                    resetOtpHandler(e);
                  }}
                >
                  Click to resend
                </Link>
              ) : (
                ""
              )}</p>
        </div>
    );
};

export default VerifyViaOTP;
